
import React, { useState, useEffect } from 'react';
import styles from '../styles/ServerFleet.module.css';
import ServerCard from './ServerCard';
import SiteTransferNotice from './SiteTransferNotice';
import { getGptCarList,getGptAPICarList, getGrokCarList, getMJCarList, getCCarList ,getSoraCarList } from '../api/carApi';
import { fetchHomeAIUrlByCarId, fetchGPTCarIdsByCarId } from '../api/orderApi';
import { useSelector } from 'react-redux';
import LoginModal from './LoginModal';
import AlertModal from './AlertModal';
import RechargeModal from './RechargeModal';
import AlertImageModal from './AlertImageModal';
import { useTranslation } from 'react-i18next'; // 添加翻译钩子


// 不同标签页的使用说明内容
// 不同标签页的使用说明内容
const usageGuideContent = {
  gpt: {
    quota: {
      title: "ServerFleet.quota.gpt.title",
      text: "ServerFleet.quota.gpt.text",
      icon: "fas fa-infinity"
    }
  },
  sora: {
    quota: {
      title: "ServerFleet.quota.sora.title",
      text: "ServerFleet.quota.sora.text",
      icon: "fas fa-film"
    }
  },

  // gpt_api: {
  //   quota: {
  //     title: "ServerFleet.quota.gpt_api.title",
  //     text: "ServerFleet.quota.gpt_api.text",
  //     icon: "fas fa-infinity"
  //   }
  // },


  claude: {
    quota: {
      title: "ServerFleet.quota.claude.title",
      text: "ServerFleet.quota.claude.text",
      icon: "fas fa-infinity"
    }
  },
  grok: {
    quota: {
      title: "ServerFleet.quota.grok.title",
      text: "ServerFleet.quota.grok.text",
      icon: "fas fa-rocket"
    }
  },
  deepseek: {
    quota: {
      title: "ServerFleet.quota.deepseek.title",
      text: "ServerFleet.quota.deepseek.text",
      icon: "fas fa-code"
    }
  },
  // gemini: {
  //   quota: {
  //     title: "ServerFleet.quota.gemini.title",
  //     text: "ServerFleet.quota.gemini.text",
  //     icon: "fas fa-infinity"
  //   }
  // },
  // mj: {
  //   quota: {
  //     title: "ServerFleet.quota.mj.title",
  //     text:  "ServerFleet.quota.mj.text",
  //     icon: "fas fa-image"
  //   }
  // }
};
// 将tabs分成两行
const topRowTabs = [
{ id: 'gpt', label: 'ServerFleet.tabs.gpt', icon: `${process.env.PUBLIC_URL}/images/gpt-main.jpg` },
{ id: 'sora', label: 'ServerFleet.tabs.sora', icon: `${process.env.PUBLIC_URL}/images/sora-car-main.jpg` },
// { id: 'gpt_api', label: 'ServerFleet.tabs.gpt_api', icon: `${process.env.PUBLIC_URL}/images/gpt-api-car.jpg` },
{ id: 'claude', label: 'ServerFleet.tabs.claude', icon: `${process.env.PUBLIC_URL}/images/claude-main.jpg` },
{ id: 'grok', label: 'ServerFleet.tabs.grok', icon: `${process.env.PUBLIC_URL}/images/grok-main.jpg` },

// { id: 'deepseek', label: 'ServerFleet.tabs.deepseek', icon: `${process.env.PUBLIC_URL}/images/deepseek-main.jpg` },

];

const bottomRowTabs = [

// { id: 'gemini', label: 'ServerFleet.tabs.gemini', icon: `${process.env.PUBLIC_URL}/images/gemini-main.jpg` },
// { id: 'mj', label: 'ServerFleet.tabs.mj', icon: `${process.env.PUBLIC_URL}/images/mj-main.jpg` },
];

// 原始tabs数组 (保持它以便其他地方的逻辑不变)
const tabs = [...topRowTabs, ...bottomRowTabs];

const filters = [
{ label: 'ServerFleet.filters.all', icon: null, color: null },
{ label: 'ServerFleet.filters.online', icon: 'fas fa-circle', color: 'var(--success-green)' },
{ label: 'ServerFleet.filters.busy', icon: 'fas fa-circle', color: 'var(--warning-yellow)' },
{ label: 'ServerFleet.filters.offline', icon: 'fas fa-circle', color: 'var(--danger-red)' },
];

const tabContent = {
gpt: { title: 'ServerFleet.tabContent.gpt.title', subtitle: 'ServerFleet.tabContent.gpt.subtitle' },
gpt_api: { title: 'ServerFleet.tabContent.gpt_api.title', subtitle: 'ServerFleet.tabContent.gpt_api.subtitle' },
sora: { title: 'ServerFleet.tabContent.sora.title', subtitle: 'ServerFleet.tabContent.sora.subtitle' },
grok: { title: 'ServerFleet.tabContent.grok.title', subtitle: 'ServerFleet.tabContent.grok.subtitle' },
gfree: { title: 'ServerFleet.tabContent.gfree.title', subtitle: 'ServerFleet.tabContent.gfree.subtitle' },
mj: { title: 'ServerFleet.tabContent.mj.title', subtitle: 'ServerFleet.tabContent.mj.subtitle' },
claude: { title: 'ServerFleet.tabContent.claude.title', subtitle: 'ServerFleet.tabContent.claude.subtitle' },
};

const expiryDateFields = {
gpt: 'expiration_date',
gpt_api: 'expiration_date_ye_chatgpt',
sora: 'expiration_date',
grok: 'expiration_date_ye_grok',
gfree: 'expiration_date_ye_grok',
mj: 'expiration_date_ye_mj',
claude: 'expiration_date_ye_claude',
claudef: 'expiration_date_ye_claude',
};

const mapStatus = (status) => {
switch (status) {
  case 1:
    return 'online';
  case 2:
    return 'busy';
  case 0:
    return 'offline';
  default:
    return 'offline';
}
};

const PlaceholderCard = () => (
<div className={styles.placeholderCard}>
  <div className={styles.placeholderHeader}></div>
  <div className={styles.placeholderContent}></div>
</div>
);

const FillerCard = () => (
<div className={styles.fillerCard}></div>
);

const formatDate = (isoDate) => {
if (!isoDate) return '未知';
const date = new Date(isoDate);
const year = date.getUTCFullYear();
const month = String(date.getUTCMonth() + 1).padStart(2, '0');
const day = String(date.getUTCDate()).padStart(2, '0');
return `${year}-${month}-${day}`;
};

const ServerFleet = () => {
const { t } = useTranslation(); // 使用翻译钩子
const [activeTab, setActiveTab] = useState('gpt');
const [activeFilter, setActiveFilter] = useState('ServerFleet.filters.all');
const [serverData, setServerData] = useState({});
const [loading, setLoading] = useState(false);
const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
const [alertMessage, setAlertMessage] = useState('');
const [isCardLoading, setIsCardLoading] = useState(false);
const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
const [isRechargeModalOpen, setIsRechargeModalOpen] = useState(false);
const [selectedTabId, setSelectedTabId] = useState(null);
const [successUrl, setSuccessUrl] = useState(null);
const [grokSubTabs, setGrokSubTabs] = useState([]);
const [activeGrokSubTab, setActiveGrokSubTab] = useState('all');
const [claudeSubTabs, setClaudeSubTabs] = useState([]); // 新增：Claude 子 tabs
const [activeClaudeSubTab, setActiveClaudeSubTab] = useState('all'); // 新增：当前激活的 Claude 子 tab
const user = useSelector((state) => state.user.user);
const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
const usertoken = user?.userToken || localStorage.getItem('userToken');
const user_key = user?.user_key || localStorage.getItem('user_key');
const [accountInfo, setAccountInfo] = useState({
  gpt: { username: t('ServerFleet.loading'), expiryDate: t('ServerFleet.loading'), daysLeft: 0 },
  gpt_api: { username: t('ServerFleet.loading'), expiryDate: t('ServerFleet.loading'), daysLeft: 0 },
  sora: { username: t('ServerFleet.loading'), expiryDate: t('ServerFleet.loading'), daysLeft: 0 },
  grok: { username: t('ServerFleet.loading'), expiryDate: t('ServerFleet.loading'), daysLeft: 0 },
  mj: { username: t('ServerFleet.loading'), expiryDate: t('ServerFleet.loading'), daysLeft: 0 },
  claude: { username: t('ServerFleet.loading'), expiryDate: t('ServerFleet.loading'), daysLeft: 0 },
});
const [expiredStatus, setExpiredStatus] = useState({});
const [isDeepseekModalOpen, setIsDeepseekModalOpen] = useState(false);
const [isGeminiModalOpen, setIsGeminiModalOpen] = useState(false);

const host = window.location.hostname;

// 新增 onLoginSuccess 处理函数
const handleLoginSuccess = (loginData) => {
  console.log('Login successful, data:', loginData);
  setIsLoginModalOpen(false); // 关闭登录模态框
  // 可选：在这里更新用户状态或触发其他操作
  // 例如，如果使用 Redux，可以 dispatch 一个 action
  // dispatch({ type: 'USER_LOGIN', payload: loginData });
};

const getCookie = (name) => {
  const value = `; ${document.cookie}`; // 添加分号以处理第一个 cookie 的情况
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null; // 如果没有找到 cookie，则返回 null
};

const checkToken = getCookie('checkToken');

const calculateDaysLeft = (expiryDate) => {
  if (!expiryDate) return 0;
  const now = new Date();
  const expiry = new Date(expiryDate);
  const timeDiff = expiry - now;
  const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
  return daysLeft > 0 ? daysLeft : 0;
};

useEffect(() => {
  console.log('useEffect triggered, user:', user, 'isLoggedIn:', isLoggedIn);
  const updateExpiredStatus = () => {
    if (isLoggedIn && user) {
      const newExpiredStatus = {};
      tabs.forEach((tab) => {
        const field = expiryDateFields[tab.id];
        const expiryDate = user[field];
        if (expiryDate) {
          const expirationDateUTC = new Date(expiryDate);
          const nowUTC = new Date();
          newExpiredStatus[tab.id] = nowUTC > expirationDateUTC;
          console.log(`${tab.id} - Expiry Date (UTC):`, expiryDate);
          console.log(`${tab.id} - Now (UTC):`, nowUTC.toISOString());
          console.log(`${tab.id} - Is Expired:`, newExpiredStatus[tab.id]);
        } else {
          newExpiredStatus[tab.id] = false;
          console.log(`${tab.id} - No expiry date found, not expired`);
        }
      });
      setExpiredStatus(newExpiredStatus);
      console.log('Updated expiredStatus:', newExpiredStatus);
    } else {
      console.log('User not logged in or no user data');
    }
  };

  updateExpiredStatus();
  const interval = setInterval(updateExpiredStatus, 60000);
  return () => clearInterval(interval);
}, [user, isLoggedIn]);

useEffect(() => {
  if (user) {
    const newAccountInfo = {};
    Object.keys(accountInfo).forEach((tabId) => {
      const expiryField = expiryDateFields[tabId];
      const rawExpiryDate = user[expiryField] || t('ServerFleet.unknown');
      const formattedExpiryDate = formatDate(rawExpiryDate);
      newAccountInfo[tabId] = {
        username: user.uid || t('ServerFleet.unknownUser'),
        expiryDate: formattedExpiryDate,
        daysLeft: calculateDaysLeft(rawExpiryDate),
      };
    });
    setAccountInfo(newAccountInfo);
  }
}, [user, activeTab, t]);

const fetchServerData = async (tabId) => {
  setLoading(true);
  if (tabId === 'deepseek') {
    return; // 不获取服务器数据
  }

  try {
    let response;
    switch (tabId) {
      case 'gpt':
        response = await getGptCarList();
        break;
      case 'gpt_api':
          response = await getGptAPICarList();
          break;
      case 'sora':
        response = await getSoraCarList();
        break;
      case 'grok':
        response = await getGrokCarList();
        break;
      case 'gfree':
        response = await getGrokCarList();
        break;
      case 'mj':
        response = await getMJCarList();
        break;
      case 'claude':
        response = await getCCarList();
        break;
      case 'claudef':
        response = await getCCarList();
        break;
      default:
        throw new Error('Unknown tab ID');
    }
    const rawData = response.data?.list || [];
    const mappedData = rawData.map((item) => ({
      name: item.carID,
      status: mapStatus(item.status),
      desc: item.desc,
      count: item.count,
      color: item.color === 'yellow' ? 'orange' : item.color,
      isSuper: tabId === 'grok' ? item.isSuper : tabId === 'claude' ? item.isPro : undefined, // 处理 Claude 的 isPro
      expiresAt: item.expiresAt, // 保存到期时间
      iqStatus: item.iqStatus, // 保存降智状态
      label: item.label, // 保存账号类型
      isMax: tabId === 'claude' ? item.isMax : undefined, // 保存Claude车队的isMax字段
    }));

    // 为 Grok 和 Claude 设置子 tab
    if (tabId === 'grok') {
      const subTabs = [
        { id: 'all', label: t('ServerFleet.subTabs.all'), icon: null },
        { id: 'super', label: t('ServerFleet.subTabs.super'), icon: null },
        { id: 'normal', label: t('ServerFleet.subTabs.normal'), icon: null },
      ];
      setGrokSubTabs(subTabs);
    } else if (tabId === 'claude') {
      const subTabs = [
        { id: 'all', label: t('ServerFleet.subTabs.all'), icon: null },
        { id: 'super', label: t('ServerFleet.subTabs.proAccount'), icon: null },
        { id: 'normal', label: t('ServerFleet.subTabs.normal'), icon: null },
      ];
      setClaudeSubTabs(subTabs);
    }

    setServerData((prev) => ({
      ...prev,
      [tabId]: mappedData,
    }));
  } catch (error) {
    console.error(`Error fetching data for ${tabId}:`, error);
    setServerData((prev) => ({
      ...prev,
      [tabId]: [],
    }));
  } finally {
    setLoading(false);
  }
};

const handleTabClick = (tabId) => {
  setActiveTab(tabId);

  if (tabId === 'deepseek') {
    setIsDeepseekModalOpen(true);
  } else if (tabId === 'gemini') {
    setIsGeminiModalOpen(true);
  }else {
    fetchServerData(tabId);
  }
  if (tabId !== 'grok') setActiveGrokSubTab('all');
  if (tabId !== 'claude') setActiveClaudeSubTab('all'); // 重置 Claude 子 tab
};

const handleFilterClick = (filterLabel) => {
  setActiveFilter(filterLabel);
};

const handleGrokSubTabClick = (subTabId) => {
  setActiveGrokSubTab(subTabId);
};

const handleClaudeSubTabClick = (subTabId) => {
  setActiveClaudeSubTab(subTabId);
};

const handleCardClick = async (tabId, server) => {
  console.log(`Card clicked for ${tabId}, server:`, server, 'expiredStatus:', expiredStatus[tabId]);

  if (expiredStatus[tabId]) {
    console.log(`${tabId} is expired, opening RechargeModal`);
    setSelectedTabId(tabId);
    setIsRechargeModalOpen(true);
    return;
  }

  console.log(`${tabId} is not expired, proceeding with normal flow`);
  if (!usertoken || !isLoggedIn) {
    console.log('User not logged in or no usertoken, opening LoginModal');
    setIsLoginModalOpen(true);
    return;
  }

  setSuccessUrl(null);
  setAlertMessage(t('ServerFleet.alerts.gettingAIResource'));
  setIsAlertModalOpen(true);
  setIsCardLoading(true);

  try {
    if (tabId === 'gpt') {
      const carId = server.name;
      const requestData = { host, usertoken, carId };
      const response = await fetchGPTCarIdsByCarId(requestData);
      console.log('fetchGPTCarIdsByCarId response:', response);
      if (response.message === 'Success' && response.url) {
        setSuccessUrl(response.url);
        window.open(response.url, '_blank');
        setAlertMessage(t('ServerFleet.alerts.redirectSuccess'));
      } else {
        setAlertMessage(`${t('ServerFleet.alerts.requestFailed')}: ${response.data?.message || t('ServerFleet.alerts.unknownError')}`);
      }
    } else {
      const carId = server.name;
      const requestData = { user_key, type: tabId, carId, host };
      console.log('fetchHomeAIUrlByCarId requestData:', requestData);
      const response = await fetchHomeAIUrlByCarId(requestData);
      console.log('fetchHomeAIUrlByCarId response:', response);
      if (response.message === 'Success' && response.data.url) {
        setSuccessUrl(response.data.url);
        window.open(response.data.url, '_blank');
        setAlertMessage(t('ServerFleet.alerts.redirectSuccess'));
      } else {
        setAlertMessage(`${t('ServerFleet.alerts.requestFailed')}: ${response.data?.message || t('ServerFleet.alerts.unknownError')}`);
      }
    }
  } catch (error) {
    console.error(`Error for ${tabId}:`, error.message);
    setAlertMessage(`${t('ServerFleet.alerts.requestFailed')}: ${error.message}`);
  } finally {
    setIsCardLoading(false);
  }
};

useEffect(() => {
  fetchServerData('gpt');
}, []);

const filteredGrokServers =
  activeTab === 'grok' && serverData['grok']
    ? (() => {
        const filtered = serverData['grok'].filter((server) =>
          t(activeFilter) === t('ServerFleet.filters.all') || server.status === activeFilter.toLowerCase()
        );
        let result = filtered;
        if (activeGrokSubTab === 'super') {
          result = filtered
            .filter((server) => server.isSuper === true)
            .sort((a, b) => (a.count || 0) - (b.count || 0));
        } else if (activeGrokSubTab === 'normal') {
          result = filtered
            .filter((server) => server.isSuper === false)
            .sort((a, b) => (a.count || 0) - (b.count || 0));
        } else if (activeGrokSubTab === 'all') {
          const superServers = filtered
            .filter((server) => server.isSuper === true)
            .sort((a, b) => (a.count || 0) - (b.count || 0));
          const normalServers = filtered
            .filter((server) => server.isSuper === false)
            .sort((a, b) => (a.count || 0) - (b.count || 0));
          result = [...superServers, ...normalServers];
        }
        return result;
      })()
    : [];

const filteredClaudeServers =
  activeTab === 'claude' && serverData['claude']
    ? (() => {
        const filtered = serverData['claude'].filter((server) =>
          t(activeFilter) === t('ServerFleet.filters.all') || server.status === activeFilter.toLowerCase()
        );
        let result = filtered;
        if (activeClaudeSubTab === 'super') {
          result = filtered
            .filter((server) => server.isSuper === true)
            .sort((a, b) => (a.count || 0) - (b.count || 0));
        } else if (activeClaudeSubTab === 'normal') {
          result = filtered
            .filter((server) => server.isSuper === false)
            .sort((a, b) => (a.count || 0) - (b.count || 0));
        } else if (activeClaudeSubTab === 'all') {
          const maxServers = filtered
            .filter((server) => server.isMax === true)
            .sort((a, b) => (a.count || 0) - (b.count || 0));
          const superServers = filtered
            .filter((server) => server.isSuper === true && server.isMax !== true)
            .sort((a, b) => (a.count || 0) - (b.count || 0));
          const normalServers = filtered
            .filter((server) => server.isSuper === false && server.isMax !== true)
            .sort((a, b) => (a.count || 0) - (b.count || 0));
          result = [...maxServers, ...superServers, ...normalServers];
        }
        return result;
      })()
    : [];

const filteredServers =
  activeTab === 'grok'
    ? filteredGrokServers
    : activeTab === 'claude'
    ? filteredClaudeServers
    : serverData[activeTab] && Array.isArray(serverData[activeTab])
    ? serverData[activeTab].filter((server) =>
        t(activeFilter) === t('ServerFleet.filters.all') || server.status === activeFilter.toLowerCase()
      )
    : [];

const MIN_CARDS = 40;
const fillerCount = Math.max(0, MIN_CARDS - filteredServers.length);

return (
  <div className={styles.container}>
    {/* 使用统一的公告栏组件 */}
    <SiteTransferNotice />

    {/* 两行标签布局 */}
    <div className={styles.serverTabsContainer}>
      {/* 第一行标签 */}
      <div className={styles.serverTabs}>
        {topRowTabs.map((tab) => (
          <button
            key={tab.id}
            className={`${styles.tabBtn} ${activeTab === tab.id ? styles.active : ''}`}
            onClick={() => handleTabClick(tab.id)}
            data-tab={tab.id}
          >
            {tab.icon && <img src={tab.icon} alt={`${t(tab.label)} icon`} className={styles.tabIcon} />}
            <span className={styles.tabLabel}>{t(tab.label)}</span>
          </button>
        ))}
      </div>
      
      {/* 第二行标签 */}
      <div className={styles.serverTabs}>
        {bottomRowTabs.map((tab) => (
          <button
            key={tab.id}
            className={`${styles.tabBtn} ${activeTab === tab.id ? styles.active : ''}`}
            onClick={() => handleTabClick(tab.id)}
            data-tab={tab.id}
          >
            {tab.icon && <img src={tab.icon} alt={`${t(tab.label)} icon`} className={styles.tabIcon} />}
            <span className={styles.tabLabel}>{t(tab.label)}</span>
          </button>
        ))}
      </div>
    </div>

    <div className={styles.accountStatusSection}>
      <div className={styles.accountStatusHeader}>
        <div className={styles.headerLeft}>
          <h3>
            【{t([...topRowTabs, ...bottomRowTabs].find(tab => tab.id === activeTab)?.label)} 】{t('ServerFleet.account.status')}
          </h3>
          {expiredStatus[activeTab] ? (
            <span className={styles.accountBadgeExpired}>{t('ServerFleet.account.expired')}</span>
          ) : (
            <span className={styles.accountBadge}>{t('ServerFleet.account.premium')}</span>
          )}
        </div>
        <button
          className={styles.upgradeButton}
          onClick={() => {
            setSelectedTabId(activeTab);
            setIsRechargeModalOpen(true);
          }}
        >
          <i className="fas fa-crown"></i>
          <span>{t('ServerFleet.account.upgradeButton')}</span>
        </button>
      </div>

      <div className={styles.accountDetailsGrid}>
        <div className={styles.accountCard}>
          <div className={styles.accountIcon}>
            <i className="fas fa-user-circle"></i>
          </div>
          <div className={styles.accountInfo}>
            <span className={styles.accountLabel}>{t('ServerFleet.account.username')}</span>
            <span className={styles.accountValue}>{accountInfo[activeTab]?.username}</span>
          </div>
        </div>

        <div className={styles.accountCard}>
          <div className={styles.accountIcon}>
            <i className="far fa-calendar-alt"></i>
          </div>
          <div className={styles.accountInfo}>
            <span className={styles.accountLabel}>{t('ServerFleet.account.expiryDate')}</span>
            <span className={styles.accountValue}>{accountInfo[activeTab]?.expiryDate}</span>
          </div>
        </div>

        <div className={styles.accountCard}>
          <div className={styles.accountIcon}>
            <i className="fas fa-hourglass-half"></i>
          </div>
          <div className={styles.accountInfo}>
            <span className={styles.accountLabel}>{t('ServerFleet.account.daysRemaining')}</span>
            <div className={styles.daysContainer}>
              <span className={styles.daysLeft}>{accountInfo[activeTab]?.daysLeft}{t('ServerFleet.account.days')}</span>
              <div className={styles.expiryBar}>
                <div
                  className={styles.expiryFill}
                  style={{ width: `${(accountInfo[activeTab]?.daysLeft / 365) * 100}%` }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {activeTab === 'grok' && grokSubTabs.length > 1 && (
      <div className={styles.subTabsContainer}>
        {grokSubTabs.map((subTab) => (
          <button
            key={subTab.id}
            className={`${styles.subTabBtn} ${activeGrokSubTab === subTab.id ? styles.active : ''}`}
            onClick={() => handleGrokSubTabClick(subTab.id)}
            data-tab={subTab.id}
          >
            {subTab.icon && <img src={subTab.icon} alt={`${subTab.label} icon`} className={styles.tabIcon} />}
            <span>{subTab.label}</span>
          </button>
        ))}
      </div>
    )}

    {activeTab === 'claude' && claudeSubTabs.length > 1 && (
      <div className={styles.subTabsContainer}>
        {claudeSubTabs.map((subTab) => (
          <button
            key={subTab.id}
            className={`${styles.subTabBtn} ${activeClaudeSubTab === subTab.id ? styles.active : ''}`}
            onClick={() => handleClaudeSubTabClick(subTab.id)}
            data-tab={subTab.id}
          >
            {subTab.icon && <img src={subTab.icon} alt={`${subTab.label} icon`} className={styles.tabIcon} />}
            <span>{subTab.label}</span>
          </button>
        ))}
      </div>
    )}

    <div className={`${styles.tabContent} ${styles.active}`} id={`${activeTab}-tab`}>
      {/* <p className={styles.tabSubtitle}>{t(tabContent[activeTab].subtitle)}</p> */}
      {loading ? (
        <div className={styles.serverGrid}>
          {Array.from({ length: 30 }).map((_, index) => (
            <PlaceholderCard key={index} />
          ))}
        </div>
      ) : (
        <div className={styles.serverGrid}>
          {filteredServers.length > 0 ? (
            <>
              {filteredServers.map((server, index) => (
                <ServerCard
                  key={index}
                  server={server}
                  tabId={activeTab}
                  onClick={handleCardClick}
                />
              ))}
              {Array.from({ length: fillerCount }).map((_, index) => (
                <FillerCard key={`filler-${index}`} />
              ))}
            </>
          ) : (
            <>
              <p>{t('ServerFleet.server.noData')}</p>
              {Array.from({ length: MIN_CARDS }).map((_, index) => (
                <FillerCard key={`filler-${index}`} />
              ))}
            </>
          )}
        </div>
      )}
    </div>

    <AlertModal
      isOpen={isAlertModalOpen}
      message={alertMessage}
      onClose={() => setIsAlertModalOpen(false)}
      onConfirm={successUrl ? () => window.location.href = successUrl : null}
      confirmText={successUrl ? t('ServerFleet.alerts.manualRedirect') : t('ServerFleet.common.confirm')}
    />

    <AlertImageModal
      isOpen={isDeepseekModalOpen || activeTab === 'deepseek'}
      message={
        <>
        <p>{t('ServerFleet.deepseek.help1')}</p>
        <p>{t('ServerFleet.deepseek.help2')}</p>
        </>
      }
      imageUrl={`${process.env.PUBLIC_URL}/images/deepseek-teacher.jpg`}
      onClose={() => {
        setIsDeepseekModalOpen(false);
        // 如果用户关闭，切换回默认标签
        if (activeTab === 'deepseek') {
          setActiveTab('gpt');
          fetchServerData('gpt');
        }
      }}
      confirmText={t('ServerFleet.common.gotIt')}
    />

    <AlertImageModal
      isOpen={isGeminiModalOpen || activeTab === 'gemini'}
      message={
        <>
          <p>{t('ServerFleet.gemini.help1')}</p>
          <p>{t('ServerFleet.gemini.help2')}</p>
          <p>{t('ServerFleet.gemini.help3')}</p>
        </>
      }
      imageUrl={`${process.env.PUBLIC_URL}/images/gemini-teacher.jpg`}
      onClose={() => {
        setIsGeminiModalOpen(false);
        // 如果用户关闭，切换回默认标签
        if (activeTab === 'gemini') {
          setActiveTab('gpt');
          fetchServerData('gpt');
        }
      }}
      confirmText={t('ServerFleet.common.gotIt')}
    />

    <LoginModal
      isOpen={isLoginModalOpen}
      onClose={() => setIsLoginModalOpen(false)}
      onLoginSuccess={handleLoginSuccess}
    />

    <RechargeModal
      isOpen={isRechargeModalOpen}
      onClose={() => setIsRechargeModalOpen(false)}
      currentTab={selectedTabId}
      userEmail={user?.email || localStorage.getItem('email')}
    />
  </div>
);
};

export default ServerFleet;
